import { render, staticRenderFns } from "./pagelayout.vue?vue&type=template&id=792ee3e9"
import script from "./pagelayout.vue?vue&type=script&lang=js"
export * from "./pagelayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports